module.exports = __webpack_public_path__ + "img/Barbell Left Salone.a18bf732.png";